import React from 'react';
import Header from './Header';
import Footer from './Footer';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-white dark:bg-black transition-colors duration-200">
      <Header />
      <main className="flex-1 pb-16">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
